export const PaperCheck = {
  "paperCheckTitle": "",
  "paperCheckTool": "",
  "discoverDescription": "",
  "discoverBtn": "",
  "noticeInfoTitle": "",
  "confirmNoticeBtn": "",
  "checkUpdateMustRead": "",
  "checkUpdateMustReadInfos": {
    "notice1": "",
    "notice2": "",
    "notice3": "",
    "notice4": ""
  },
  "checkSafeAndCost": "",
  "checkSafeAndCostInfos": {
    "notice1": "",
    "notice2": "",
    "notice3": ""
  },
  "disclaimerInfo": "",
  "disclaimerInfoDetails": {
    "disclaimerInfo1": "",
    "disclaimerInfo2": "",
    "disclaimerInfo3": ""
  },
  "checkHistory": "",
  "paperCheckStep": {
    "setting": "",
    "payment": "",
    "finish": ""
  },
  "nextStep": "",
  "prevStep": "",
  "cancel": "",
  "confirm": "",
  "saveBtn": "",
  "paymentBtn": "",
  "choiceOther": "",
  "uploadText": "",
  "uploadDesc": "",
  "loadingFile": "",
  "colon": "",
  "checkTypeContent": {
    "new": "",
    "published": ""
  },
  "checkEngineContent": {
    "wanFang": ""
  },
  "partnerName": {
    "wanFang": ""
  },
  "checkCostTip": "",
  "checkCostTipOfPrice": "",
  "checkEngineTip": "",
  "checkPublishDateLabel": "",
  "checkPublishDateErrorTip": "",
  "checkPublishDateLabeTip": "",
  "checkPublishDateTip": {
    "tip1": "",
    "tip2": "",
    "tip3": "",
    "tip4": "",
    "tip5": ""
  },
  "checkPaperTitleLabel": "",
  "checkPaperTitleTip": "",
  "checkPaperTitleErrorTip": "",
  "checkPaperAuthorLabel": "",
  "checkPaperAuthorTip": "",
  "checkPaperAuthorErrorTip": "",
  "checkCountsTipTitle": "",
  "checkCountsTipDesc": "",
  "checkOrderTitle": "",
  "checkOderThanksTip": "",
  "checkOrderTime": "",
  "checkType": "",
  "checkEngine": "",
  "loadingPriceErrorTip": "",
  "loadingPriceErrorRetry": "",
  "unitPrice": "",
  "unitPriceContent": "",
  "totalPriceNum": "",
  "totalPrice": "",
  "totalPriceLabel": "",
  "checkCountsInPaymentTip": "",
  "checkCountsText": "",
  "checkSubmitSuccess": "",
  "checkSubmitSuccessRemainTimeInfo": "",
  "checkSubmitSuccessSaveTimeInfo": "",
  "saveCheckReportTip": "",
  "viewCheckResult": "",
  "continueCheck": "",
  "checkStatusContent": {
    "Checking": "",
    "Error": "",
    "Success": ""
  },
  "toastTip": {
    "successTitle": "",
    "successInfo": "",
    "failedTitle": "",
    "failedInfo": ""
  },
  "checkSuccess": {
    "title": "",
    "checkOther": "",
    "copyPercent": "",
    "copyPercentHighTip": "",
    "copyPercentOkTip": "",
    "exportWholeReport": "",
    "viewMarkReport": "",
    "checkCountsTextLabel": "",
    "checkSuccessTimeLabel": ""
  },
  "checkError": {
    "title": "",
    "Exception": "",
    "Error": "",
    "Timeout": ""
  },
  "contactUs": "",
  "noticeTitle": "",
  "needSaveTitle": "",
  "loadFileFailedTitle": "",
  "documentPasswordProtectTitle": "",
  "passwordLabel": "",
  "passwordErrorTip": "",
  "alreadyExistCheckTitle": "",
  "reportExpiredTip": "",
  "searchCheckHistoryTip": "",
  "searchNoCheckHistoryTip": "",
  "noMore": "",
  "noCheckHistory": "",
  "verifyFileTip": {
    "needSave": "",
    "notSupportFileType": "",
    "maxSizeTip": "",
    "noTextExtractionPermissionTip": "",
    "alreadyExistCheck": "",
    "maxCheckCounts": "",
    "emptyFile": "",
    "errorPwd": "",
    "extractFileError": ""
  },
  "loadingTxt": "",
  "payment": {
    "title": "",
    "totalPriceLabel": "",
    "paymentTip": "",
    "paymentCheck": "",
    "paymentErrorTip": "",
    "paymentCancelTip": "",
    "continuePay": "",
    "cancelPay": ""
  },
  "loadPaymentPageError": "",
  "bindEmail": {
    "title": "",
    "description": "",
    "bindEmailSuccess": "",
    "bindEmailFailure": "!",
    "sendCodeSuccess": "",
    "sendCodeFailure": "",
    "emailTip": "",
    "emailRegRuleMsg": "",
    "emailRequiredRuleMsg": "",
    "emailInUseMsg": "",
    "codeTip": "",
    "codeRegRuleMsg": "",
    "codeRequiredRuleMsg": "",
    "codeErrorMsg": "",
    "getCode": "",
    "reSend": ""
  }
}